import ErrorWithToast from "./ErrorWithToast";

class BadDevNoCoffee extends ErrorWithToast {
  constructor(error, status) {
    super(error?.message || "Algo de errado aconteceu :(", status);
  }
}

export default BadDevNoCoffee;
